import { MemoryStore } from "@i.un/libs";
import { type UserInfoType } from "@/stores";

type GlobalStatus = {
  userProfile?: UserInfoType;
  logged: boolean;
  linkedinLogged: boolean;
};

type TStatus = {
  global: GlobalStatus;
};

function getStatusStore<T extends keyof TStatus>(key: T) {
  return MemoryStore.create<TStatus[T]>(key);
}

export function getStatus() {
  return getStatusStore("global");
}

// const status = getStatus();

// status.get("userProfile");
// status.set("logged", true);
// status.set("linkedinLogged", true);

// status.get("logged");
// status.get("linkedinLogged");